import React from 'react';
import { Box, Inline, Stack, xcss } from '@atlaskit/primitives';
import Skeleton from '@atlaskit/skeleton';
export const LoadingModalBodyDescription = () => /*#__PURE__*/React.createElement(Stack, {
  space: "space.200"
}, /*#__PURE__*/React.createElement(Skeleton, {
  width: "95%",
  height: "16px",
  isShimmering: true
}), /*#__PURE__*/React.createElement(Skeleton, {
  width: "95%",
  height: "16px",
  isShimmering: true
}), /*#__PURE__*/React.createElement(Skeleton, {
  width: "35%",
  height: "16px",
  isShimmering: true
}));
export const LoadingModalBodyContent = ({
  isEdit
}) => /*#__PURE__*/React.createElement(Box, {
  xcss: skeletonWrapperStyles
}, /*#__PURE__*/React.createElement(Stack, {
  space: "space.200"
}, isEdit && /*#__PURE__*/React.createElement(Skeleton, {
  width: "100%",
  height: "40px",
  isShimmering: true
}), /*#__PURE__*/React.createElement(Inline, {
  spread: "space-between"
}, /*#__PURE__*/React.createElement(Skeleton, {
  width: "50%",
  height: "25px",
  isShimmering: true
}), /*#__PURE__*/React.createElement(Skeleton, {
  width: "20%",
  height: "25px",
  isShimmering: true
})), /*#__PURE__*/React.createElement(Inline, {
  spread: "space-between"
}, /*#__PURE__*/React.createElement(Skeleton, {
  width: "50%",
  height: "25px",
  isShimmering: true
}), /*#__PURE__*/React.createElement(Skeleton, {
  width: "20%",
  height: "25px",
  isShimmering: true
}))));
const skeletonWrapperStyles = xcss({
  width: '95%'
});